import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
import { default as request } from "@pb/utils/request";
import { default as getCookie } from "@pb/utils/getCookie";
import { default as consoleEvents } from "@pb/utils/consoleEvents";
import { default as getUserFeatures } from "@pb/utils/getUserFeatures";
import { Breakpoints } from "@pb/utils/constants/breakpoints";
import { default as useMediaQuery } from "@pb/utils/reactHooks/useMediaQuery";
import { default as getPbCookie } from "@pb/utils/getPbCookie";
import { default as getCorporateBrandId } from "@pb/utils/getCorporateBrandId";
import { currentBrand } from "@pb/utils/brandConfig";
import cn from 'classnames';
import { isValidPhoneNumber } from 'react-phone-number-input';
import ProductGrid from "../../compositions/ProductGrid";
import Label from "../Label";
import { IconButton, CTALink } from "../../ui/CTA";
import Button from "../../ui/CTA/Button";
import CheckBoxInput from "../../ui/Fields/CheckBoxInput";
import PhoneNumberInput from "../../ui/Fields/PhoneNumberInput";
import RadioButtonInput from "../../ui/Fields/RadioButtonInput";
import { AppStoreIcon, GooglePlayIcon } from "../../ui/Icon";
import Modal from "../../ui/Modal";
import BodyText from "../../ui/Typography/texts/BodyText";
import MetaText from "../../ui/Typography/texts/MetaText";
import Preamble from "../../ui/Typography/texts/Preamble";
import HeadingLarge from "../../ui/Typography/titles/HeadingLarge";
import HeadingMedium from "../../ui/Typography/titles/HeadingMedium";
import HeadingSmall from "../../ui/Typography/titles/HeadingSmall";
import getSimilarItems from '../SimilarItemsRecoCarousel/helpers/getSimilarItems';
import trackProductEvent from '../SimilarItemsRecoCarousel/helpers/trackProductEvent';
import { TrackingEvent } from '../SimilarItemsRecoCarousel/types';
import Selector from './components/Selector';
import { NiBConstant } from './helpers/constants';
import { getActiveNibSmsMarkets } from './helpers/getActiveNibSmsMarkets';
import { getVariation, trackOptimizelyVanillaEvent } from './helpers/optimizely';
import { trackNiBCompleteSuccess, trackNibShowBecomeMember, trackAppStoreClick, trackOnNibInitiate, } from './helpers/tracking';
import styles from './NotifyIfBack.module.scss';
const LIST_NAME = 'Similar items NIB';
export const getCookieInfo = (notifyIfBack) => {
    const userCookie = notifyIfBack === 'pb' ? getPbCookie() : getCookie('userCookie');
    if (userCookie) {
        const dataInJSON = JSON.parse(userCookie);
        const userEmail = dataInJSON ? dataInJSON.hybris_uuid : '';
        const bpid = dataInJSON ? dataInJSON.bpid : '';
        return { userEmail, bpid };
    }
    return { userEmail: '', bpid: '' };
};
const updatedActivatedOosItems = (code, array) => array &&
    array.map((a) => {
        const modifiedItem = a.value === code ? Object.assign(Object.assign({}, a), { isActive: true }) : Object.assign(Object.assign({}, a), { isActive: false });
        return modifiedItem;
    });
const activatedOosItems = (array) => array === null || array === void 0 ? void 0 : array.map((a) => {
    const modifiedItem = a.isActive !== true ? Object.assign(Object.assign({}, a), { isActive: false }) : a;
    return modifiedItem;
});
const findPreActivatedOosItems = (array) => {
    const findActivatedItem = array && array.find((a) => a.isActive === true && a.value !== undefined);
    return (findActivatedItem === null || findActivatedItem === void 0 ? void 0 : findActivatedItem.value) || undefined;
};
const findActiveItemSizeLabel = (array) => {
    const findActivatedItemSize = array && array.find((a) => a.isActive === true && a.label !== undefined);
    return (findActivatedItemSize === null || findActivatedItemSize === void 0 ? void 0 : findActivatedItemSize.label) || undefined;
};
const portFolioBrand = 'pb';
const PbPhoneInputWrapperClassName = 'PbPhoneInputWrapper';
const numberSimilarItemsInGrid = 4;
const NotifyIfBack = ({ oosItems, triggerOpen, toggleModal, notifyIfBack = 'none', handleShowOverlay, nibSpacing, nibTextAlignment, nibApiUrl, isCalledFromFavorite, nibHeadingAlignment, nibModalCloseIconSize, nibModalCloseIconStyle, nibButtonSize, nibModalTitleSize, nibSizeSelectorClassName, productName, productCategory, productId, nibPbSms = false, nibPbSmsClassName = 'nibOptionsSms', nibPbEmailClassName = 'nibOptionsEmail', nibModalType, isNibSimilarItemsEnabled = false, productOriginalPrice, prodductListPrice, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const [isOpen, setIsOpen] = useState(false);
    const [isSignedIn, setIsSignedIn] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(null);
    const [selectedVariant, setSelectedVariant] = useState('');
    const [cookieData, setCookieData] = useState();
    const [items, setItems] = useState(undefined);
    const [isDownloadAppBannerVisibile, setIsDownloadAppBannerVisibile] = useState(false);
    const [bannerContent, setBannerContent] = useState();
    const [nibMethod, setNibMethod] = useState('email');
    const [emailCheckboxValue, setEmailCheckboxValue] = useState(false);
    const [smsCheckboxValue, setSmsCheckboxValue] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [invalidPhoneNumberError, setInvalidPhoneNumberError] = useState(undefined);
    const [isSignedInModalOpen, setIsSignedInModalOpen] = useState(false);
    const [isSignedInUpdated, setIsSignedInUpdated] = useState(false);
    const [selectedItemSizelabel, setSelectedItemSizelabel] = useState('');
    const [products, setProducts] = useState([]);
    const [visibleProducts, setVisibleProducts] = useState(numberSimilarItemsInGrid);
    const [trackedProducts, setTrackedProducts] = useState([]);
    const isXSmallScreen = useMediaQuery(Breakpoints.XSMALL);
    const isSmallScreen = useMediaQuery(Breakpoints.SMALL);
    const isMediumScreen = useMediaQuery(Breakpoints.MEDIUM);
    const userFeatures = getUserFeatures();
    const isPbNotifyIfBack = notifyIfBack === 'pb';
    const pbLocale = getCookie('HMCORP_locale');
    let heading;
    let info;
    let text;
    let boldText;
    let button;
    let onClickButton;
    let disabledButton = false;
    let mobilePhoneText;
    let productCategoryCode;
    const markets = currentBrand !== 'monki' ? getActiveNibSmsMarkets() : [];
    const ProductCategorySummary = (_a = window.productArticleDetails) === null || _a === void 0 ? void 0 : _a.mainCategorySummary;
    if (isCalledFromFavorite) {
        productCategoryCode = productCategory;
    }
    else if (ProductCategorySummary.indexOf('-') !== -1) {
        productCategoryCode = (_b = ProductCategorySummary === null || ProductCategorySummary === void 0 ? void 0 : ProductCategorySummary.split('-')[1]) === null || _b === void 0 ? void 0 : _b.trim();
    }
    const categoryCode = productCategoryCode || '';
    const marketLocale = (pbLocale === null || pbLocale === void 0 ? void 0 : pbLocale.toLowerCase()) || '';
    const market = ((_c = pbLocale === null || pbLocale === void 0 ? void 0 : pbLocale.split('_')[1]) === null || _c === void 0 ? void 0 : _c.toUpperCase()) || '';
    const productKey = isCalledFromFavorite
        ? productId
        : ((_d = window.productArticleDetails) === null || _d === void 0 ? void 0 : _d.articleCode) || '';
    const handleMarketLocale = () => {
        if (marketLocale === 'en_gb' || marketLocale === 'da_dk') {
            return 'en_eur';
        }
        if (currentBrand === 'cos' && marketLocale === 'sv_se') {
            return 'en_eur';
        }
        if (marketLocale === 'en_us') {
            return 'en_usd';
        }
        return marketLocale;
    };
    const trackViewedProducts = (eventType, currentSlide) => {
        const viewedProducts = products.slice(currentSlide, currentSlide + visibleProducts);
        const productsToTrack = viewedProducts.filter((product) => !trackedProducts.includes(product));
        setTrackedProducts(trackedProducts.concat(productsToTrack));
        if (productsToTrack.length) {
            trackProductEvent(eventType, productsToTrack, currentSlide, LIST_NAME);
        }
    };
    const handleNibProductTracking = (clickedProduct) => {
        const itemPosition = products.findIndex((product) => product.articleCode === (clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.articleCode));
        trackProductEvent(TrackingEvent.CLICK, [clickedProduct], itemPosition, LIST_NAME);
    };
    const fetchSimilarItems = () => __awaiter(void 0, void 0, void 0, function* () {
        const updatedMarketLocale = handleMarketLocale();
        const productCode = productKey === null || productKey === void 0 ? void 0 : productKey.substring(0, 7);
        const group = productKey === null || productKey === void 0 ? void 0 : productKey.substring(7);
        const productFormattedKey = `${productCode}_group_${group}_${updatedMarketLocale}`;
        const similarItems = yield getSimilarItems(categoryCode, updatedMarketLocale, market, productFormattedKey);
        setProducts(similarItems);
    });
    const onSubmitRequest = (reqData) => __awaiter(void 0, void 0, void 0, function* () {
        var _y, _z, _0;
        const apiUrl = isPbNotifyIfBack ? nibApiUrl : ((_0 = (_z = (_y = window === null || window === void 0 ? void 0 : window.hm) === null || _y === void 0 ? void 0 : _y.options) === null || _z === void 0 ? void 0 : _z.notifyIfBack) === null || _0 === void 0 ? void 0 : _0.apiUrl) || '';
        setSubmitLoading(true);
        try {
            const result = yield request.post(apiUrl, { data: reqData });
            setSubmitLoading(false);
            return result.data;
        }
        catch (error) {
            setSubmitLoading(false);
            return error;
        }
    });
    const updateSelectedValue = (code) => {
        setSelectedVariant(code);
        setItems(updatedActivatedOosItems(code, items));
    };
    const fetchUser = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            request.get('v2/user', {
                use: { apiVersion: false },
            })
                .then((response) => {
                var _a, _b, _c;
                const contructPhoneNumber = (((_a = response.data) === null || _a === void 0 ? void 0 : _a.cellPhone) && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.prefix) + ((_c = response.data) === null || _c === void 0 ? void 0 : _c.cellPhone)) || '';
                setPhoneNumber(contructPhoneNumber);
            });
        }
        catch (error) {
            consoleEvents.error(error);
        }
    });
    const closeModal = () => {
        var _a, _b;
        setIsOpen(false);
        setEmailCheckboxValue(false);
        setSmsCheckboxValue(false);
        if (phoneNumber)
            setPhoneNumber('');
        if (toggleModal)
            toggleModal();
        appeaser === null || appeaser === void 0 ? void 0 : appeaser.publish((_b = (_a = appeaser === null || appeaser === void 0 ? void 0 : appeaser.Enums) === null || _a === void 0 ? void 0 : _a.listen) === null || _b === void 0 ? void 0 : _b.ON_NIB_MODAL_CLOSE);
    };
    const signInJourney = () => {
        var _a, _b, _c;
        if (notifyIfBack === 'pb') {
            const isSignInModalExists = document.querySelector('.nib.is-open');
            if (!isSignInModalExists && getCorporateBrandId() !== 6) {
                closeModal();
                appeaser === null || appeaser === void 0 ? void 0 : appeaser.publish('SHOW_LIGHTBOX', { template: 'sign-in', classes: 'nib' });
                appeaser === null || appeaser === void 0 ? void 0 : appeaser.publish(appeaser.Enums.listen.ON_SIGN_IN_POPUP_OPEN);
            }
            else {
                closeModal();
                appeaser === null || appeaser === void 0 ? void 0 : appeaser.publish('SHOW_MY_ACCOUNT_BLOCK');
                appeaser === null || appeaser === void 0 ? void 0 : appeaser.publish(appeaser.Enums.listen.ON_SIGN_IN_POPUP_OPEN);
            }
            if (handleShowOverlay)
                handleShowOverlay();
        }
        else if ((_c = (_b = (_a = hm === null || hm === void 0 ? void 0 : hm.Remodal) === null || _a === void 0 ? void 0 : _a.Utils) === null || _b === void 0 ? void 0 : _b.Actions) === null || _c === void 0 ? void 0 : _c.showModal) {
            hm.Remodal.Utils.Actions.showModal('signin');
        }
        else {
            consoleEvents.error('hm.Remodal.Utils.Actions.showModal not found');
        }
    };
    const locale = notifyIfBack !== 'pb' ? (_f = (_e = hm === null || hm === void 0 ? void 0 : hm.options) === null || _e === void 0 ? void 0 : _e.product) === null || _f === void 0 ? void 0 : _f.locale : pbLocale;
    const country = (_g = locale.split('_')[1]) === null || _g === void 0 ? void 0 : _g.toUpperCase();
    const userEmail = cookieData === null || cookieData === void 0 ? void 0 : cookieData.userEmail;
    const selectorText = React.createElement(Label, { copyKey: "notifyIfBack.modal.select.selectSize" });
    const submitRequest = () => __awaiter(void 0, void 0, void 0, function* () {
        // For pb brands if sms option is enabled and phone number field is not valid don't submit the form.
        if (smsCheckboxValue && nibPbSms) {
            if (!isValidPhoneNumber(phoneNumber)) {
                setInvalidPhoneNumberError(getLabelFromStorage('notifyIfBack.modal.select.invalidPhoneNumber_text'));
                disabledButton = true;
                return;
            }
        }
        const result = yield onSubmitRequest(Object.assign({ bpid: cookieData === null || cookieData === void 0 ? void 0 : cookieData.bpid, email: cookieData === null || cookieData === void 0 ? void 0 : cookieData.userEmail, phonenumber: phoneNumber, locale, variant: selectedVariant, channel: nibMethod === 'both' ? '0' : nibMethod === 'email' ? '1' : '2' }, (notifyIfBack === 'pb' && { corporateBrandId: getCorporateBrandId() })));
        const isNibFormSubmittedSuccessfully = !!(result === null || result === void 0 ? void 0 : result.success);
        setIsSubmitSuccessful(isNibFormSubmittedSuccessfully);
        if (isNibFormSubmittedSuccessfully) {
            trackNiBCompleteSuccess({
                product_article_id: notifyIfBack !== 'pb'
                    ? selectedVariant.slice(0, -3)
                    : selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.toString().slice(0, -3),
                product_size_code: notifyIfBack !== 'pb'
                    ? selectedVariant.slice(-3)
                    : selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.toString().slice(-3),
            }, isCalledFromFavorite, productName, productCategory, selectedItemSizelabel, nibMethod, productOriginalPrice, prodductListPrice);
        }
    });
    const handleNibKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (isSubmitSuccessful === null) {
                submitRequest();
            }
            else {
                closeModal();
            }
        }
    };
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (isOpen) {
            trackOnNibInitiate({
                product_article_id: ((_b = (_a = window === null || window === void 0 ? void 0 : window.hm) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.getArticleId()) || '',
                product_size_code: ((_d = (_c = window === null || window === void 0 ? void 0 : window.hm) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.getSelectedSize()) || '',
            }, isCalledFromFavorite);
            if (!((_e = getCookieInfo(notifyIfBack)) === null || _e === void 0 ? void 0 : _e.userEmail) && notifyIfBack !== 'pb') {
                trackNibShowBecomeMember({
                    product_article_id: ((_g = (_f = window === null || window === void 0 ? void 0 : window.hm) === null || _f === void 0 ? void 0 : _f.product) === null || _g === void 0 ? void 0 : _g.getArticleId()) || '',
                    product_size_code: ((_j = (_h = window === null || window === void 0 ? void 0 : window.hm) === null || _h === void 0 ? void 0 : _h.product) === null || _j === void 0 ? void 0 : _j.getSelectedSize()) || '',
                });
            }
        }
    }, [isOpen, notifyIfBack]);
    useEffect(() => {
        if (products.length) {
            trackViewedProducts(TrackingEvent.IMPRESSION, 0);
        }
    }, [products, visibleProducts]);
    useEffect(() => {
        var _a, _b;
        setItems(activatedOosItems(oosItems));
        setIsSubmitSuccessful(null);
        setSelectedVariant(((_a = oosItems === null || oosItems === void 0 ? void 0 : oosItems.find((item) => item.isActive === true)) === null || _a === void 0 ? void 0 : _a.value) || '');
        setSelectedItemSizelabel(((_b = oosItems === null || oosItems === void 0 ? void 0 : oosItems.find((item) => item.isActive === true)) === null || _b === void 0 ? void 0 : _b.label) || '');
        const cookieInfo = getCookieInfo(notifyIfBack);
        setCookieData(cookieInfo);
        if (triggerOpen) {
            setIsOpen(triggerOpen);
        }
        if (nibPbSms) {
            fetchUser();
        }
        if (isNibSimilarItemsEnabled) {
            fetchSimilarItems();
        }
    }, [triggerOpen]);
    useEffect(() => {
        const activeItemValue = items && findPreActivatedOosItems(items);
        if (activeItemValue) {
            setSelectedVariant(activeItemValue);
        }
        if (notifyIfBack === 'pb') {
            const activeItemSizeLabel = items && findActiveItemSizeLabel(items);
            if (activeItemSizeLabel) {
                setSelectedItemSizelabel(activeItemSizeLabel);
            }
        }
    }, [items]);
    useEffect(() => {
        if (cookieData) {
            setIsSignedIn(!!(cookieData === null || cookieData === void 0 ? void 0 : cookieData.userEmail));
            setIsSignedInUpdated(true);
        }
    }, [cookieData]);
    useEffect(() => {
        if (isSubmitSuccessful) {
            getVariation([NiBConstant.VARIABLE_BANNER_OBJECT])
                .then((data) => {
                if (data === null || data === void 0 ? void 0 : data.flag) {
                    setIsDownloadAppBannerVisibile(data.flag);
                    setBannerContent(data.download_app_content);
                    trackOptimizelyVanillaEvent(NiBConstant.VIEW_DOWNLOAD_APP_COMPONENT);
                }
            })
                .catch((e) => {
                consoleEvents.error('Error in Favorite and Cart Items On Sale component', e);
            });
        }
    }, [isSubmitSuccessful]);
    useEffect(() => {
        if (emailCheckboxValue && !smsCheckboxValue) {
            setNibMethod('email');
        }
        if (smsCheckboxValue && !emailCheckboxValue) {
            setNibMethod('sms');
        }
        if (emailCheckboxValue && smsCheckboxValue) {
            setNibMethod('both');
        }
    }, [emailCheckboxValue, smsCheckboxValue]);
    if (notifyIfBack === 'pb' && !isSignedIn && isSignedInUpdated) {
        if (!isSignedInModalOpen && triggerOpen) {
            setIsSignedInModalOpen(true);
            signInJourney();
        }
    }
    else if (notifyIfBack !== 'pb' && !isSignedIn && isSignedInUpdated) {
        heading = React.createElement(Label, { copyKey: "notifyIfBack.modal.login.heading" });
        info = React.createElement(Label, { copyKey: "notifyIfBack.modal.login.info" });
        text = React.createElement(Label, { copyKey: "notifyIfBack.modal.login.text" });
        button = React.createElement(Label, { copyKey: "notifyIfBack.modal.login.button" });
        onClickButton = signInJourney;
    }
    else {
        switch (isSubmitSuccessful) {
            case false:
                heading = React.createElement(Label, { copyKey: "notifyIfBack.modal.error.heading" });
                info = React.createElement(Label, { copyKey: "notifyIfBack.modal.error.info" });
                button = React.createElement(Label, { copyKey: "notifyIfBack.modal.error.button" });
                onClickButton = submitRequest;
                break;
            case true:
                heading = React.createElement(Label, { copyKey: "notifyIfBack.modal.success.heading_text" });
                info = React.createElement(Label, { copyKey: "nib.email.when.back", replacements: userEmail });
                button = React.createElement(Label, { copyKey: "notifyIfBack.modal.success.button_text" });
                onClickButton = closeModal;
                break;
            default:
                heading = React.createElement(Label, { copyKey: "notifyIfBack.modal.select.heading_text" });
                info = React.createElement(Label, { copyKey: "notifyIfBack.modal.select.info_text" });
                boldText = React.createElement(Label, { copyKey: "notifyIfBack.modal.select.emailLabel_text" });
                text = React.createElement("span", { className: styles.userEmailAddress }, userEmail);
                mobilePhoneText = React.createElement(Label, { copyKey: "notifyIfBack.modal.select.phoneLabel_text" });
                button = React.createElement(Label, { copyKey: "notifyIfBack.notifyMeList" });
                onClickButton = submitRequest;
                if (selectedVariant === '') {
                    disabledButton = true;
                }
                else if (((_k = (_j = (_h = window === null || window === void 0 ? void 0 : window.hm) === null || _h === void 0 ? void 0 : _h.options) === null || _j === void 0 ? void 0 : _j.notifyIfBack) === null || _k === void 0 ? void 0 : _k.email) ||
                    ((_o = (_m = (_l = window === null || window === void 0 ? void 0 : window.hm) === null || _l === void 0 ? void 0 : _l.options) === null || _m === void 0 ? void 0 : _m.notifyIfBack) === null || _o === void 0 ? void 0 : _o.sms)) {
                    if (nibMethod === 'both') {
                        disabledButton =
                            !phoneNumber || !userEmail || !!(phoneNumber && invalidPhoneNumberError);
                    }
                    else if (nibMethod === 'sms') {
                        disabledButton = !phoneNumber || !!(phoneNumber && invalidPhoneNumberError);
                    }
                    else {
                        disabledButton = !userEmail;
                    }
                }
                else if (nibPbSms && markets.includes(country)) {
                    disabledButton = !emailCheckboxValue && !smsCheckboxValue;
                }
        }
    }
    const trackStoreClick = (appStoreName) => {
        const tags = {
            bpid: userFeatures.bpid,
        };
        if (appStoreName === 'App Store') {
            trackOptimizelyVanillaEvent(NiBConstant.EVENTS_CLICK_APP_STORE, tags);
        }
        else {
            trackOptimizelyVanillaEvent(NiBConstant.EVENTS_CLICK_GOOGLE_PLAY, tags);
        }
        trackAppStoreClick(appStoreName);
    };
    const validatePhoneNumber = () => {
        if (!isValidPhoneNumber(phoneNumber) && !invalidPhoneNumberError && smsCheckboxValue) {
            setInvalidPhoneNumberError(getLabelFromStorage('notifyIfBack.modal.select.invalidPhoneNumber_text'));
        }
        else if (isValidPhoneNumber(phoneNumber) && invalidPhoneNumberError) {
            setInvalidPhoneNumberError(undefined);
        }
    };
    const title = getLabelFromStorage('notifyIfBack.notifyMeList');
    const close = getLabelFromStorage('general.close');
    const handleShowMoreClick = () => {
        setVisibleProducts(visibleProducts + numberSimilarItemsInGrid);
    };
    return (React.createElement(Modal, { customTitle: isSubmitSuccessful === null &&
            (nibModalTitleSize === 'small' ? (React.createElement(HeadingSmall, { Tag: "h3" }, title)) : nibModalTitleSize === 'normal' ? (React.createElement(HeadingMedium, null, title)) : (React.createElement(HeadingLarge, null, title))), closeButtonText: close, isOpen: isOpen, isDownloadAppBannerAccessible: true, toggleModal: closeModal, textAlign: "left", modalTitleClassName: styles.nibModalTitle, innerContainerClassName: cn(styles.modalWrapper, nibTextAlignment && styles[nibTextAlignment], notifyIfBack === portFolioBrand && `nib-${currentBrand}`), modalType: nibModalType ||
            (isXSmallScreen || isSmallScreen || isMediumScreen ? 'fullScreen' : 'middle'), disableRemoveScroll: true, headingAlignment: nibHeadingAlignment, closeIconSize: nibModalCloseIconSize, closeIconStyle: nibModalCloseIconStyle },
        isSubmitSuccessful ? (React.createElement(React.Fragment, null,
            React.createElement(Preamble, { className: cn(styles.successHeading, nibSpacing && styles[nibSpacing], notifyIfBack === portFolioBrand && `nib-${currentBrand}-successHeading`) }, heading),
            (nibMethod === 'both' || nibMethod === 'email') && (React.createElement(HeadingSmall, { Tag: "span", className: cn(styles.successInfo, nibSpacing && styles[nibSpacing]) }, userEmail)),
            (nibMethod === 'both' || nibMethod === 'sms') && (React.createElement(HeadingSmall, { Tag: "span", className: cn(styles.successInfo, styles.phone) }, phoneNumber)))) : (React.createElement(React.Fragment, null, notifyIfBack !== 'pb' ? (React.createElement(React.Fragment, null,
            heading && (React.createElement(HeadingMedium, { className: cn(styles.innerHeading) }, heading)),
            info && (React.createElement(Preamble, { className: cn(styles.infoText, !heading && styles.infoTextTop) }, info)))) : (info && (React.createElement(BodyText, { className: cn(styles.infoText, !heading && styles.infoTextTop) }, info))))),
        isSignedIn && isSubmitSuccessful === null && (React.createElement("div", { className: cn(styles.sizeSelector, isPbNotifyIfBack && styles.pbSizeSelector, nibSizeSelectorClassName) },
            React.createElement(Selector, { label: selectorText, items: items, onSizePick: (code) => updateSelectedValue(code), isPbNotifyIfBack: isPbNotifyIfBack }))),
        isSignedIn &&
            ((_r = (_q = (_p = window === null || window === void 0 ? void 0 : window.hm) === null || _p === void 0 ? void 0 : _p.options) === null || _q === void 0 ? void 0 : _q.notifyIfBack) === null || _r === void 0 ? void 0 : _r.email) &&
            ((_u = (_t = (_s = window === null || window === void 0 ? void 0 : window.hm) === null || _s === void 0 ? void 0 : _s.options) === null || _t === void 0 ? void 0 : _t.notifyIfBack) === null || _u === void 0 ? void 0 : _u.sms) &&
            isSubmitSuccessful === null && (React.createElement(React.Fragment, null,
            React.createElement(HeadingSmall, { Tag: "h3", className: cn(styles.nibMethodsTitle) },
                React.createElement(Label, { copyKey: "notifyIfBack.modal.select.reminderFormTitle_text" })),
            React.createElement("div", { role: "radiogroup", className: cn(styles.nibMethods) },
                React.createElement(RadioButtonInput, { id: "email", name: "radio-group", inputValue: "email", label: React.createElement(BodyText, { className: styles.nibOptionItemLabel },
                        React.createElement(Label, { copyKey: "notifyIfBack.modal.select.emailMethodLabel_text" })), checked: nibMethod === 'email', onChange: (value) => setNibMethod(value) }),
                React.createElement(RadioButtonInput, { id: "sms", name: "radio-group", inputValue: "sms", label: React.createElement(BodyText, { className: styles.nibOptionItemLabel },
                        React.createElement(Label, { copyKey: "notifyIfBack.modal.select.phoneMethodLabel_text" })), checked: nibMethod === 'sms', onChange: (value) => setNibMethod(value) }),
                React.createElement(RadioButtonInput, { id: "both", name: "radio-group", inputValue: "both", label: React.createElement(BodyText, { className: styles.nibOptionItemLabel },
                        React.createElement(Label, { copyKey: "notifyIfBack.modal.select.bothMethodLabel_text" })), checked: nibMethod === 'both', onChange: (value) => setNibMethod(value) })))),
        (nibMethod === 'both' || nibMethod === 'email') && !nibPbSms && boldText && (React.createElement(BodyText, { className: cn(styles.emailWrapper) },
            boldText,
            " ",
            text)),
        isSignedIn && nibPbSms && isSubmitSuccessful === null && (React.createElement(React.Fragment, null,
            markets.includes(country) && (React.createElement("div", { className: styles.PbNibOptions },
                React.createElement(BodyText, null,
                    React.createElement(Label, { copyKey: "notifyIfBack.modal.select.MethodLabel_text" })),
                React.createElement(CheckBoxInput, { className: nibPbEmailClassName, name: "check-group-email", borderStyle: "square", checkboxStyle: "crossMark", inputID: "email", checked: emailCheckboxValue, label: React.createElement(BodyText, { className: cn(styles.emailWrapper) },
                        boldText,
                        " ",
                        text), onChange: () => setEmailCheckboxValue(!emailCheckboxValue), onKeyDown: (e) => e.key === 'Enter' && setEmailCheckboxValue(!emailCheckboxValue) }),
                React.createElement(CheckBoxInput, { className: nibPbSmsClassName, name: "check-group-sms", borderStyle: "square", checkboxStyle: "crossMark", inputID: "sms", checked: smsCheckboxValue, label: React.createElement(BodyText, { className: cn(styles.emailWrapper) }, mobilePhoneText), onChange: () => setSmsCheckboxValue(!smsCheckboxValue), onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            setSmsCheckboxValue(!smsCheckboxValue);
                        }
                    } }),
                React.createElement(PhoneNumberInput, { onChange: (value) => setPhoneNumber(value), value: phoneNumber, error: invalidPhoneNumberError, onBlurCallBack: validatePhoneNumber, country: country, defaultCountry: country, countries: [country], className: PbPhoneInputWrapperClassName }))),
            !markets.includes(country) && (React.createElement(BodyText, { className: cn(styles.emailWrapper) },
                boldText,
                " ",
                text)))),
        (nibMethod === 'both' || nibMethod === 'sms') &&
            ((_x = (_w = (_v = window === null || window === void 0 ? void 0 : window.hm) === null || _v === void 0 ? void 0 : _v.options) === null || _w === void 0 ? void 0 : _w.notifyIfBack) === null || _x === void 0 ? void 0 : _x.sms) &&
            isSubmitSuccessful === null && (React.createElement("div", { className: cn(styles.phoneInputWrapper) },
            React.createElement(PhoneNumberInput, { label: getLabelFromStorage('notifyIfBack.modal.select.phoneLabel_text'), onChange: (value) => setPhoneNumber(value), value: phoneNumber, error: invalidPhoneNumberError, onBlurCallBack: validatePhoneNumber, placeholder: getLabelFromStorage('notifyIfBack.modal.select.phonePlaceholder_text'), country: country, defaultCountry: country, international: false, countries: [country], addInternationalOption: false }),
            React.createElement(MetaText, { className: cn(styles.phoneExample) },
                React.createElement(Label, { copyKey: "notifyIfBack.modal.select.examplePhoneNumber_text" })))),
        notifyIfBack !== 'pb' && isSignedIn && isSubmitSuccessful === null && (React.createElement(BodyText, { className: cn(styles.nibDescription) },
            React.createElement(Label, { copyKey: nibMethod === 'both'
                    ? 'notifyIfBack.modal.select.warningInfoFull_text'
                    : nibMethod === 'sms'
                        ? 'notifyIfBack.modal.select.warningInfoPhone_text'
                        : 'notifyIfBack.modal.select.warningInfoEmail_text' }),
            ' ',
            React.createElement(CTALink, { className: styles.privacyLink, href: "customer-service/legal-and-privacy/privacy-link.html" },
                React.createElement(Label, { copyKey: "notifyIfBack.modal.select.privacyLink_text" })),
            ".")),
        button && (React.createElement(Button, { type: "button", onClick: onClickButton, onKeyDown: handleNibKeyDown, className: cn(styles.nibModalButton, nibSpacing && styles[nibSpacing], notifyIfBack === 'pb' && styles.pb, {
                [styles.continueShopping]: !!isSubmitSuccessful,
                [styles.mobileMode]: isXSmallScreen || isSmallScreen || isMediumScreen,
            }), disabled: disabledButton || submitLoading, size: nibButtonSize }, button)),
        isSubmitSuccessful && isDownloadAppBannerVisibile && (React.createElement("div", { className: styles.appStoreContainer },
            bannerContent && (React.createElement(React.Fragment, null,
                React.createElement(HeadingMedium, null, bannerContent[locale].banner_title),
                React.createElement(BodyText, null, bannerContent[locale].banner_description))),
            React.createElement(IconButton, { Tag: "a", className: styles.appStoreIcon, target: "_blank", rel: "noreferrer nofollow", href: "https://apps.apple.com/app/h-m/id834465911", onClick: () => trackStoreClick('App Store'), iconElement: React.createElement(AppStoreIcon, { className: styles.appStoreLink }) }, "App Store"),
            React.createElement(IconButton, { Tag: "a", target: "_blank", rel: "noreferrer nofollow", className: styles.appStoreIcon, href: "https://play.google.com/store/apps/details?id=com.hm.goe", onClick: () => trackStoreClick('Google Play'), iconElement: React.createElement(GooglePlayIcon, { className: styles.appStoreLink }) }, "Google Play"))),
        isNibSimilarItemsEnabled && products.length > 0 && (React.createElement("div", { className: styles.nibPraWrapper },
            React.createElement("p", null, getLabelFromStorage('notifyIfBack.modal.similar.items.heading')),
            React.createElement(ProductGrid, { products: products.slice(0, visibleProducts), numberOfColumns: {
                    xsmall: 2,
                    small: 2,
                    medium: 2,
                    large: 2,
                    xlarge: 2,
                    xxl: 2,
                }, gridGap: "large", onProductClick: (clickedProduct) => {
                    handleNibProductTracking(clickedProduct);
                } }),
            visibleProducts < products.length && (React.createElement(Button, { className: styles.showMoreButton, size: "large", fullWidth: true, secondary: true, onClick: handleShowMoreClick }, getLabelFromStorage('notifyIfBack.modal.view.more.similar.products')))))));
};
export default NotifyIfBack;
//# sourceMappingURL=NotifyIfBack.js.map